export const EDIT_QUOTE_FLAG = 'PCC_editQuoteFlag';
export const CREATE_QUOTE_BUTTON_POPOVER_SEEN =
  'createQuoteButton_Popover_Seen';
export const CREATE_QUOTE_BUTTON_TOOLTIP_SEEN =
  'createQuoteButton_Tooltip_Seen';
